import styles from "./TextareaBlock.module.scss";

import { useState } from "react";

// components
import { Heading, Textarea } from "../../Components";

export default function TextareaBlock() {
  const [value, setValue] = useState<string>("");

  return (
    <div className={styles["textarea-block-root"]}>
      <Heading title="Textarea" />

      <div style={{ marginTop: "32px" }} />

      <div className={styles["block"]}>
        <span className={styles["label"]}>Default</span>
        <Textarea
          id="default-textarea"
          name="default-textarea"
          placeholder="Placeholder text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
    </div>
  );
}
